import { createSelector } from "reselect";
import { Location } from "../../../@types/location";
import { RootState } from "../../rootReducer";

const getLocations = (locations: Location[], parent?: Location): Location[] =>
  locations
    .filter(({ partOf }) => partOf === (parent?.id || null))
    .map((location) => ({
      ...location,
      childs: getLocations(locations, location),
    }));

export const selectLocations = createSelector(
  [
    (store: RootState) => store.locations.locations,
    (store: RootState) => store.locations.partOfFilter,
    (store: RootState) => store.locations.searchText,
  ],
  (data, partOfSelected, searchText) => {
    const partsOf = partOfSelected.map(({ id }) => id);
    return data
      .filter(
        ({ partOf, name, category, usersCount }) =>
          usersCount &&
          name?.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()) &&
          category?.id == "4" &&
          (!partsOf.length || partsOf.includes(partOf))
      )
      .sort((a, b) => ((a.usersCount || 0) < (b.usersCount || 0) ? 1 : -1));
  }
);
